const galeriaItems = [
  {
    img: "https://static.readdy.ai/image/ea473d33d180c87428df5c28ba90939d/3e4c939ab93524fe8bf8eaada48eb3b6.jpeg",
    label: "Nuestro almacén",
  },
  {
    img: "https://static.readdy.ai/image/ea473d33d180c87428df5c28ba90939d/190cd41caa9578fa73286362e1b7e00c.jpeg",
    label: "Repuestos de motor",
  },
  {
    img: "https://static.readdy.ai/image/ea473d33d180c87428df5c28ba90939d/54f9f8969b478563dc492e67bdf61145.jpeg",
    label: "Envíos a todo Colombia",
  },
  {
    img: "https://static.readdy.ai/image/ea473d33d180c87428df5c28ba90939d/90688cf684e83b54f756fecc449d14d0.jpeg",
    label: "Asesoría personalizada",
  },
  {
    img: "https://static.readdy.ai/image/ea473d33d180c87428df5c28ba90939d/7ec3962db22f8713b333d50e21d708d6.jpeg",
    label: "Suspensión y frenos",
  },
  {
    img: "https://static.readdy.ai/image/ea473d33d180c87428df5c28ba90939d/88faa55b173f777de94823f751b1b0bd.jpeg",
    label: "Sistema eléctrico",
  },
  {
    img: "https://storage.readdy-site.link/project_files/612e0f9c-0b99-40dc-a3d7-604b2920f6ee/be38fc0e-ede1-49ae-a402-1bb106f8593c_WhatsApp-Image-2026-04-15-at-11.48.00-AM.jpeg?v=eda65b701f1a252c7a98a121a3e44686",
    label: "Repuestos originales",
  },
  {
    img: "https://storage.readdy-site.link/project_files/612e0f9c-0b99-40dc-a3d7-604b2920f6ee/4f22b96f-2969-494d-a558-577a901ddd2e_WhatsApp-Image-2026-04-15-at-11.47.59-AM-2.jpeg?v=c0a0578c834f8be281393ca26343e696",
    label: "Variedad de productos",
  },
  {
    img: "https://storage.readdy-site.link/project_files/612e0f9c-0b99-40dc-a3d7-604b2920f6ee/bc5b6537-6911-4d2f-971d-d4ac1c493347_WhatsApp-Image-2026-04-15-at-11.47.58-AM.jpeg?v=fb3c6627dae2a7cc84965b725e77a17b",
    label: "Atención al cliente",
  },
];

export default function GaleriaSection() {
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-14">
          <span className="text-[#E10600] text-xs font-black uppercase tracking-widest mb-3 block">
            Galería
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-black mb-4">
            Nuestro negocio en imágenes
          </h2>
          <p className="text-gray-500 text-base md:text-lg max-w-xl mx-auto">
            Conoce nuestro almacén, nuestros repuestos y el servicio que ofrecemos a cada cliente.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {galeriaItems.map((item) => (
            <a
              key={item.label}
              href="https://www.youtube.com/watch?v=8Zsw4lYVfXc"
              target="_blank"
              rel="nofollow noreferrer"
              className="relative rounded-xl overflow-hidden group h-56 md:h-64 block cursor-pointer"
            >
              <img
                src={item.img}
                alt={`${item.label} - Repuestos Octavio Ospina`}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                <span className="text-white font-bold text-sm">{item.label}</span>
              </div>
              <div className="absolute top-3 left-3 bg-[#E10600] text-white text-xs font-bold px-3 py-1 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                {item.label}
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
